<template>
  <header class="main-header">
    <div class="logo">
      <div class="svg-stitcher-logo"></div>
      <h1 class="logo-text">{{title}}</h1>
    </div>
    <button  v-show='isLoggedIn' class="profile" @click="onProfileClicked" ref="profileButton">
      <span class="profile__name">Sam Fonoimoana<i class="fas fa-angle-down"></i></span>
      <img v-if="user_image" class="profile__image" :src="user_image" alt="profile" />
      <div v-else class="profile__initials">SF</div>
    </button>
    <div class="profile__nav" ref="profileNav" id="profileNav">
      <a @click='logout' ><i class="fas fa-sign-out-alt"></i>Logout</a>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Header',
  components: {
  },
  data () {
    return {
      profileNav: null,
      navHeight: null,
      profileButton: null,
      mouseIn: false,
      user_image: false,
      title: process.env.VUE_APP_TITLE
    }
  },
  props: {
    hide_search: {
      type: String,
      default: 'false'
    }
  },
  computed: {
    ...mapState({ user_name: 'username' }),
    user_initials () {
      return (this.user_name) ? this.user_name[0] : '?'
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  mounted () {
    this.init()
    window.addEventListener('click', () => this.checkOpenNav())
  },
  methods: {
    logout () {
      this.$store.dispatch('data/logout')
        .then(() => {
          this.$router.push('/login')
        })
    },
    init () {
      this.navHeight = this.$refs.profileNav.clientHeight

      const profileTop = this.$refs.profileButton.getBoundingClientRect().top
      const profileWidth = this.$refs.profileButton.clientWidth
      const profileHeight = this.$refs.profileButton.clientHeight

      this.$refs.profileNav.setAttribute('style', `position: absolute; top: ${profileTop}px; right: 50px; width: ${profileWidth + 30}px; padding-top: ${profileHeight}px; max-height: 0px;`)
      this.$refs.profileNav.classList.add('closed')
    },
    /**
       * check if the user nav is open when click on the nav.
       * @return {void}
       */
    checkOpenNav () {
      if (this.$refs.profileNav !== undefined) {
        if (this.$refs.profileNav.classList.contains('open')) {
          this.toggleNav()
        }
      }
    },
    /**
       * user clicked profile button on header
       * @param  {obj} event Event
       * @return void
       */
    onProfileClicked (event) {
      event.stopPropagation()
      this.toggleNav()
    },
    /**
       * toggle nav open or closed
       * @return {[type]} [description]
       */
    toggleNav () {
      const profileTop = this.$refs.profileButton.getBoundingClientRect().top
      const profileLeft = this.$refs.profileButton.getBoundingClientRect().left
      const profileWidth = this.$refs.profileButton.clientWidth
      const profileHeight = this.$refs.profileButton.clientHeight

      if (this.$refs.profileNav.classList.contains('open')) {
        this.$refs.profileNav.setAttribute('style', `position: absolute; top: ${profileTop}px; left: ${profileLeft}px; width: ${profileWidth}px; padding-top: ${profileHeight}px; max-height: 0px;`)
        this.$refs.profileNav.classList.remove('open')
        this.$refs.profileNav.classList.add('closed')
        this.$refs.profileButton.classList.remove('open')
      } else {
        this.$refs.profileNav.setAttribute('style', `position: absolute; top: ${profileTop}px; left: ${profileLeft}px; width: ${profileWidth}px; padding-top: ${profileHeight}px; max-height: ${this.navHeight + profileHeight}px;`)
        this.$refs.profileNav.classList.remove('closed')
        this.$refs.profileNav.classList.add('open')
        this.$refs.profileButton.classList.add('open')
      }
    }
  }
}
</script>
